import { useEffect, useState } from "react"
import api from "../../api/api"
import { useAuth } from '../../features/auth/AuthContext'
import SearchComponent from "../SearchComponent/SearchComponent"
import { search } from "../../assets/images/images";
import { MenuItem, Pagination } from "@mui/material";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import { ReactSVG } from "react-svg";
import sort from "../../assets/images/sort.svg";
import StyledMenu from "../../components/StyleMenu"
import SearchBar from "../Search/SearchBar";
import { convertTo12Hour } from "../BookAMeeting/meetingUtils";



const MeetingRevenue = () => {
  const { token } = useAuth()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchBar, setSearchBar] = useState("");
  const [copyData, setCopyData] = useState([])
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [summary, setSummary] = useState(null);

  const PAGE_SIZE = 12;

  // Helper to convert time range (e.g., "9:00 - 17:00") to 12-hour format (e.g., "9:00AM - 5:00PM")
  const formatTimeSlotTo12Hour = (timeSlot) => {
    if (!timeSlot) return timeSlot;
    const parts = timeSlot.split(" - ");
    if (parts.length === 2) {
      return `${convertTo12Hour(parts[0].trim())} - ${convertTo12Hour(parts[1].trim())}`;
    }
    return convertTo12Hour(timeSlot);
  };

  const [selectSort, setSelectSort] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const fetchMeetingRevenue = async (page = 1) => {
      setData([]);


    setLoading(true);
    try {
      const response = await api.get('/payouts/meetings/revenue/', {
        params: {
          page,
          search: debouncedSearch,
          sort: selectSort,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      if (response.status === 200 || response.status === 201) {
        const data = response?.data?.data;
        const summary = response?.data?.summary;
        // console.warn("data", data);

        setData(data)
        setCopyData(data)
        setSummary(summary)

        setNextUrl(response?.data?.next || null);
        setPrevUrl(response?.data?.previous || null);

        const count = response?.data?.count || 0;
        setTotalPages(Math.ceil(count / PAGE_SIZE));

      } else {
        console.error(response);

      }
    } catch (error) {
      console.error(error);

    } finally {
      setLoading(false);
    }
  }


  useEffect(() => {
    fetchMeetingRevenue(currentPage)
  }, [currentPage, debouncedSearch, selectSort])


  //   const cleanString = (str) => {
  //   return str.replace(/[^a-zA-Z0-9 ]/g, "").toLowerCase();
  // };

  // const handleSearch = (e) => {
  //   const value = e.target.value.trimStart();
  //   setSearchBar(value);

  //   if (e.key === "Enter") {
  //     setCurrentPage(1);
  //     setDebouncedSearch(value);
  //   }

  //   if (e.key === "Backspace" && value.length <= 1) {
  //     setCurrentPage(1);
  //     setDebouncedSearch("");
  //   }

  // }

  const handleSearch = (e) => {
  const value = e.target.value.trimStart();
  setSearchBar(value);
};
useEffect(() => {
  const timer = setTimeout(() => {
    setCurrentPage(1);
    setDebouncedSearch(searchBar);
  }, 500);

  return () => clearTimeout(timer);
}, [searchBar]);







  const changeSort = (sortType) => {
    setCurrentPage(1);
    setSelectSort(sortType);
  };

  return (
    <>

      <div className="filter-section">
        {/* <div className="search_header-container"> */}
        <SearchComponent
          search={search}
          searchPlaceholder="Search Student"
          searchValue="search"
          onchange={handleSearch}
          name="searchOption"
          value={searchBar}
        />
        {/* </div> */}
        <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
          <span style={{ cursor: "pointer" }} onClick={handleClick}><img src={sort} alt="sort" />Sort</span>
          {/* <ReactSVG
            id="demo-customized-button"
            aria-controls={open1 ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open1 ? "true" : undefined}
          // src={down_arrow}
          /> */}
          <StyledMenu
            anchorEl={anchorEl}
            id="account-menu"
            open={open1}
            onClose={handleClose}
            onClick={handleClose}
            slotProps={{
              paper: {
                minWidth: 180,
                elevation: 0,
                sx: {
                  overflow: "visible",
                  // filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    w0idth: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 4,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              selected={selectSort === "net_earnings_high_to_low"}
              onClick={() => changeSort("net_earnings_high_to_low")}
            >
              Net Earnings : High to Low
            </MenuItem>
            <MenuItem
              selected={selectSort === "net_earnings_low_to_high"}
              onClick={() => changeSort("net_earnings_low_to_high")}
            >
              Net Earnings : Low to High
            </MenuItem>
            <MenuItem
              selected={selectSort === "date_high_to_low"}
              onClick={() => changeSort("date_high_to_low")}
            >
              Date : Newest First
            </MenuItem>
            <MenuItem
              selected={selectSort === "date_low_to_high"}
              onClick={() => changeSort("date_low_to_high")}
            >
              Date : Oldest First
            </MenuItem>

          </StyledMenu>
        </div>
      </div>

      <div className="!hidden md:!block">
        <table className="revenue-table">
          <thead>
            <tr>
              <th>Student Name</th>
              <th className="text-center">Date</th>
              <th className="text-center">Time Slot</th>
              <th className="text-center">Session Type</th>
              <th className="text-center">Gross Revenue</th>
              <th className="text-center">Platform Fee (30%)</th>
              <th className="text-center">Net Earnings</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr>
              <td colSpan={7} style={{ textAlign: "center", padding: "12px" }}>
                Loading Revenue history...
              </td>
            </tr>}
            {!loading && data.length === 0 && (
              <tr>
                <td colSpan={7} style={{ textAlign: "center", padding: "12px" }}>
                  No Revenue history found.
                </td>
              </tr>
            )}
            {
              data.map((d) => {
                return (
                  <tr key={d?.booking_id}>
                    <td className='datafield'>{d?.student_name?.length > 20 ? `${d.student_name.substring(0, 30)}...` : d?.student_name || "-"}</td>
                    <td className="text-center">{d?.date ? new Date(d.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"}</td>
                    <td className="text-center">{d?.time_slot ? formatTimeSlotTo12Hour(d.time_slot) : "-"}</td>
                    <td className="!text-[#000000] font-medium text-center">{d?.session_type || "-"}</td>
                    <td className="text-center">{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.gross_revenue)}</td>
                    <td className="text-center">-{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.platform_fee)}</td>
                    <td className="!text-[#000000] font-medium text-center">{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.net_earnings)}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      {/* Pagination — desktop only */}

      {/* mobile crads */}
      <div className="!block md:!hidden">
{!loading && data.length === 0 && (
    <div className="flex flex-col items-center justify-center gap-2 bg-white rounded-2xl border border-gray-100 shadow-sm py-10 px-4">
      <p className="text-sm font-semibold text-gray-700">No Revenue history found.</p>
    </div>
  )}
        {!loading && data.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {data.map((d) => (
              <div
                key={d?.booking_id}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4"
              >
                {/* Divider */}
                <div className="border-t border-gray-100 mb-3" />

                {/* Info Grid — 2 cols */}
                <div className="grid grid-cols-2 gap-3">

                  {/* Student Name */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Student Name
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.student_name?.length > 30 ? `${d.student_name.substring(0, 30)}...` : d?.student_name || "—"}
                    </span>
                  </div>

                  {/* Date */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Date
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.date
                        ? new Date(d.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
                        : "—"}
                    </span>
                  </div>

                  {/* Time Slot */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Time Slot
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.time_slot ? formatTimeSlotTo12Hour(d.time_slot) : "—"}
                    </span>
                  </div>

                  {/* Session Type */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Session Type
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.session_type || "—"}
                    </span>
                  </div>

                  {/* Gross Revenue */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Gross Revenue
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.gross_revenue)}
                    </span>
                  </div>

                  {/* Platform Fee */}
                  <div className="flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Platform Fee (30%)
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      -{d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.platform_fee)}
                    </span>
                  </div>

                  {/* Net Earnings - full width */}
                  <div className="col-span-2 flex flex-col gap-1 bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Net Earnings
                    </span>
                    <span className="text-[10px] font-medium text-gray-600 uppercase tracking-wide">
                      {d?.currency_symbol || ""}{new Intl.NumberFormat("en-IN").format(d?.net_earnings)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
            {totalPages > 1 && (
        <div className='pagination-revenue'>
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              siblingCount={1}
              boundaryCount={1}
            />
          </Grid>
        </div>
      )}
    </>
  )
}

export default MeetingRevenue;